export enum AuthorityStockCorrection {
  MOVIMENTATION_STOCKCORRECTION = '13.1',
}
